import React from 'react';
import styles from './BorderedIcon.module.scss';
import SVGIcon from './SVGIcon';

type SVGIconProps = Omit<React.ComponentProps<typeof SVGIcon>, 'children'>;

interface BorderedIconProps extends SVGIconProps {
  children: React.ReactNode;
}

const BorderedIcon = ({ children, ...svgIconProps }: BorderedIconProps) => {
  return (
    <div className={styles.container}>
      {typeof children === 'string' ? (
        <SVGIcon {...svgIconProps}>{children}</SVGIcon>
      ) : (
        children
      )}
    </div>
  );
};

export default BorderedIcon;
